import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

// Matches the backend's MessageReport.REASONS enum (models/MessageReport.js).
const REASONS = [
    { value: 'spam', label: 'Spam' },
    { value: 'harassment', label: 'Harassment' },
    { value: 'hate', label: 'Hate speech' },
    { value: 'inappropriate', label: 'Inappropriate content' },
    { value: 'other', label: 'Other' },
];

// Shared reason/details modal for both "Report message" and "Report student",
// following the responsive Modal shell used across Support (fullscreen on
// mobile, centered on desktop).
const ReportModal = ({ show, onHide, title, submitting, error, onSubmit }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 767.98px)' });
    const [reason, setReason] = useState('');
    const [details, setDetails] = useState('');
    const [formError, setFormError] = useState('');

    useEffect(() => {
        if (show) {
            setReason('');
            setDetails('');
            setFormError('');
        }
    }, [show]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!reason) {
            setFormError('Please select a reason.');
            return;
        }
        setFormError('');
        onSubmit({ reason, details: details.trim() || undefined });
    };

    return (
        <Modal
            className={isMobile ? 'with-form discovery-filter-mobile-modal discovery-filter-mobile-modal--fullscreen' : 'with-form'}
            show={show}
            onHide={onHide}
            centered={!isMobile}
            fullscreen={isMobile}
        >
            <Form onSubmit={handleSubmit} className={isMobile ? 'discovery-filter-mobile-panel' : undefined}>
                {isMobile ? (
                    <div className="discovery-filter-mobile-panel__header">
                        <Modal.Title>{title}</Modal.Title>
                        <div className="discovery-filter-mobile-panel__header-actions">
                            <button type="button" className="discovery-filter-mobile-panel__close" aria-label="Close" onClick={onHide}>
                                &times;
                            </button>
                        </div>
                    </div>
                ) : (
                    <Modal.Header closeButton>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                )}
                <Modal.Body>
                    {(formError || error) && <Alert variant="danger">{formError || error}</Alert>}
                    <Form.Group className="mb-3" controlId="reportReason">
                        <Form.Label>Reason <span className="text-danger">*</span></Form.Label>
                        <Form.Select value={reason} onChange={(e) => setReason(e.target.value)}>
                            <option value="">Please select</option>
                            {REASONS.map((r) => (
                                <option key={r.value} value={r.value}>{r.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group controlId="reportDetails">
                        <Form.Label>Details <span className="text-muted fw-normal">(optional)</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            maxLength={1000}
                            value={details}
                            onChange={(e) => setDetails(e.target.value)}
                            placeholder="Add any extra context…"
                        />
                    </Form.Group>
                </Modal.Body>
                {isMobile ? (
                    <div className="discovery-filter-mobile-panel__footer">
                        <Button variant="primary" type="submit" disabled={submitting}>
                            {submitting ? 'Sending…' : 'Submit report'}
                        </Button>
                    </div>
                ) : (
                    <Modal.Footer>
                        <Button variant="outline-secondary" className="me-3" onClick={onHide}>Cancel</Button>
                        <Button variant="primary" type="submit" disabled={submitting}>
                            {submitting ? 'Sending…' : 'Submit report'}
                        </Button>
                    </Modal.Footer>
                )}
            </Form>
        </Modal>
    );
};

export default ReportModal;
